import React from 'react';
import { Helmet } from 'react-helmet';

import Layout from '../components/Layout';
import Story from '../components/Story';
import story from '../data/02-charly-palmer';

const ErinMitchell = () => (
  <>
    <Helmet>
      <script>history.scrollRestoration = &quot;manual&quot;</script>
    </Helmet>
    <Layout header={story.header}>
      <Story story={story} />
    </Layout>
  </>
);

export default ErinMitchell;
